import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PlatformAppEventEmitter } from '@wix/public-editor-platform-events';
import { EnvironmentContext, ApplicationContext, PlatformEnvironment } from '@wix/editor-application-context';
import { Essentials, biEventSteps } from './Essentials';
/**
 * This code is executed within the main thread
 */
export class PlatformWorkerManager {
  constructor(privateAPI,
  // do we need privateAPI here?
  workerStrategy, frameStrategy, events) {
    this.privateAPI = privateAPI;
    this.workerStrategy = workerStrategy;
    this.frameStrategy = frameStrategy;
    this.events = events;
    _defineProperty(this, "essentials", void 0);
    this.essentials = new Essentials({
      bi: {
        metaSiteId: this.privateAPI.info.getMetaSiteId(),
        userId: this.privateAPI.info.getUser(),
        editorSessionId: this.privateAPI.info.getEditorSessionId(),
        editorType: this.privateAPI.info.getEditorType(),
        sdkVersion: '2.0'
      }
    });

    // TODO: rename – subscribeToExternalEvents()?
    this.subscribeOnPrivateEvents();
    this.subscribeOnAppEvents();
  }
  reportBiEvent(event) {
    if (!event.meta.bi) {
      return;
    }
    if (event.meta.error && event.meta.step === biEventSteps.error) {
      this.essentials.bi.reportError({
        ...event.meta.bi,
        error: event.meta.error
      });
    } else {
      this.essentials.bi.reportBi({
        ...event.meta.bi,
        step: event.meta.step
      });
    }
  }
  subscribeOnPrivateEvents() {
    this.events.subscribe(event => {
      this.reportBiEvent(event);
      /**
       * translate events into worker
       */
      this.workerStrategy.forEachWorker(workerAPI => {
        void workerAPI.notify(event);
      });
      this.frameStrategy.notify(event);
    });
  }
  subscribeOnAppEvents() {
    this.workerStrategy.onWorkerEvent(event => {
      this.reportBiEvent(event);
    });
  }
  getWorkerAPI() {
    return this.workerStrategy.getWorkerAPI();
  }
  getWixClientHost(appDefinitionId) {
    if (appDefinitionId === void 0) {
      appDefinitionId = '';
    }
    const env = new EnvironmentContext({
      environment: PlatformEnvironment.ComponentPanel,
      privateApi: this.privateAPI,
      events: new PlatformAppEventEmitter()
    });
    return {
      channel: {
        observeState: async () => {
          return {
            disconnect() {}
          };
        }
      },
      environmentContext: env,
      applicationContext: new ApplicationContext({
        appDefinitionId
      }, env)
    };
  }
  async connectFrame(appDefinitionId,
  // spec
  iframe) {
    return this.frameStrategy.connect(appDefinitionId, iframe);
  }
}
//# sourceMappingURL=PlatformWorkerManager.js.map